import { render, staticRenderFns } from "./dui-rating.vue?vue&type=template&id=56f284c0&scoped=true&"
import script from "./dui-rating.vue?vue&type=script&lang=js&"
export * from "./dui-rating.vue?vue&type=script&lang=js&"
import style0 from "./dui-rating.vue?vue&type=style&index=0&id=56f284c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f284c0",
  null
  
)

export default component.exports